<template>
  <b-modal
    id="addContactDetails"
    size="xl"
    :title="this.$translate('New Contact')"
    hide-footer
    centered
    content-class="rounded-8"
    @close="clear"
    @show="show"
    @hide="hide"
  >
    <div class="row">
      <div v-for="i in upsert" :key="i.value" :class="` col-lg-6 col-sm-12 col-xs-12 ${i.type === 'color' ? 'center-color' : ''}`">
        <Input v-model="data[i.value]" :form-group-id="i.name" :placeholder="i.name" :required="i.required" />
      </div>
      <div class="row">
        <div class="col-12 col-lg-12 col-sm-12 col-xs-12 button-wrapper">
          <b-button variant="outline-secondary" size="sm" class="btn-delete-device px-5" @click="close">
            {{ 'Close' | i18n }}
          </b-button>
          <b-button
            variant="outline-primary"
            size="sm"
            class="btn-delete-device ml-4 px-5"
            :disabled="submitDissabled"
            @click="onSubmit"
          >
            {{ 'Save' | i18n }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from '../../../../common/input';
import Notification from '../../../../common/notification';

import { NotificationMixin } from '../../../../../../mixins';
import api from '../../../../../api';

export default {
  title: 'New Contact',
  components: { Input },
  mixins: [NotificationMixin],
  props: {
    afterSave: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      upsert: [
        { value: 'company', name: 'Company', required: true },
        { value: 'name', name: 'First name', required: true },
        { value: 'surname', name: 'Surname', required: true },
        { value: 'email', name: 'Email', required: true },
        { value: 'telephoneNumber', name: 'Telephone Number', required: true },
        { value: 'mobileNumber', name: 'Mobile Number' },
        { value: 'emergencyNumber', name: 'Emergency Number' },
        { value: 'title', name: 'Title' }
      ],
      data: {},
      preventCloseLocal: true,
      initDataForCheck: {}
    };
  },
  computed: {
    submitDissabled: function() {
      let isDissabled = false;
      this.upsert.forEach(u => {
        if (u.required && !this.data[u.value]) {
          isDissabled = true;
        }
      });
      return isDissabled;
    }
  },
  methods: {
    async show() {
      this.clear();
      this.initDataForCheck = Object.assign({}, this.data);
    },
    close() {
      this.$root.$emit('bv::hide::modal', 'addContactDetails');
    },
    clear() {
      this.data = {};
    },
    hide(e) {
      let isModified = true;

      const lengthCurrent = Object.keys(this.data).length;
      const lengthInit = Object.keys(this.initDataForCheck).length;
      if (lengthCurrent == lengthInit) {
        isModified = false;
      }

      if (this.preventCloseLocal && isModified) {
        let message = confirm(this.$translate('You have not saved your progress Are you sure you want to leave this page'));
        if (!message) {
          return e.preventDefault();
        }
        this.clear();
      }
    },
    async onSubmit() {
      try {
        this.preventCloseLocal = false;
        await api.contactDetails.create(this.data);
        this.$root.$emit('bv::hide::modal', 'addContactDetails');
        await this.afterSave();
        Notification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        Notification({ type: 'error', message: err.message });
        this.preventCloseLocal = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep  #add-customer .modal-dialog {
  max-width: 700px !important;
}

::v-deep  .button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.center-color {
  justify-content: center;
  align-items: center;
  display: flex;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
